import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import type { ReactNode } from "react";

type GuestRouteProps = {
    children: ReactNode;
};

export default function GuestRoute({ children }: GuestRouteProps) {
    // Ambil data langsung dari memori/localStorage via Context
    const { user, loading } = useAuth();

    // 1. Tampilkan Loading hanya jika Context sedang baca LocalStorage (biasanya super cepat/instant)
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-slate-50 dark:bg-slate-900">
                <div className="h-10 w-10 border-4 border-slate-300 border-t-blue-600 rounded-full animate-spin"></div>
            </div>
        );
    }

    // 2. Jika USER ADA (Sudah Login) -> Tendang ke Dashboard
    //    (Jangan biarkan user yang sudah login melihat halaman login)
    if (user) {
        return <Navigate to="/dashboard" replace />;
    }

    // 3. Jika TIDAK ADA user (Guest) -> Boleh lihat halaman Login
    return <>{children}</>;
}